<template>
  <div class="popover-feedback">
    <div class="title">请点击提交建议</div>
    <div class="desc">100%回复响应</div>
  </div>
</template>

<script>


export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.popover-feedback {
  padding: 16px 46px;
  display: flex;
  flex-direction: column;
  >div {
    white-space: nowrap;
  }
  .title {
    font-size: 14px;
    color: #2F333D;
    line-height: 18px;
  }
  .desc {
    margin-top: 4px;
    font-size: 12px;
    color: #5F666E;
    line-height: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/popover/popover-feedback.vue